import { useGateways } from "core/gateways-context";

import { HttpError } from "@bps/http-client";
import { useQuery } from "@tanstack/react-query";

import { AppointmentTypeTGArgs, AppointmentTypeTGDto } from "./tenant.dtos";

const CacheKeys = {
  OrgUnits: "orgUnits",
  Providers: "providers",
  LicenceMappings: "licenceMappings",
  AppointmentTypesTG: "appointmentTypesTG"
};

export const useAppointmentTypesTG = (
  appointmentTypeArgs?: AppointmentTypeTGArgs
) => {
  const { tenantApi } = useGateways();

  // Measure to ensure requests with the same id's but different order aren't considered as a new query
  const sortedIds = [...(appointmentTypeArgs?.appointmentTypeIds ?? [])].sort(
    (a, b) => (a < b ? -1 : 1)
  );

  return useQuery<AppointmentTypeTGDto[], HttpError>({
    queryKey: [CacheKeys.AppointmentTypesTG, sortedIds],
    queryFn: async () =>
      await tenantApi.getAppointmentTypesTG(appointmentTypeArgs)
  });
};
